<template lang="pug">
div
  div.text-md.font-semibold.neutral700--text Sharing
  v-row.mt-5(no-gutters)
    v-col(cols="5")
      div.text-sm.font-semibold.neutral500--text Register link
      v-text-field.text-sm.mt-2.round-xl(:value="getQRLinkURL()" outlined dense height="48" readonly hide-details="auto")
        template(#append)
          v-icon.mt-1(size="24" color="neutral700" @click="copyUrl" v-clipboard:copy="getQRLinkURL()") $yzi-copy-03
  
  div.text-md.font-semibold.neutral700--text.mt-6 {{ $t('qr_code') }}
  div.text-sm.font-normal.neutral700--text {{ $t('qr_code_desc', { item: 'review page' }) }}

  div.mt-3.d-flex.align-center
    vue-qrcode.ml-n1(id="reviewLink" :value="getQRLinkURL()" :options="{ width: 144 }")
    div.ml-6(style="width: 200px")
      v-btn.round-lg.text-md.font-bold.text-none.pl-5.pr-4.py-3(color="basic700" outlined depressed height="48" @click="downloadPdf")
        v-icon(left color="basic700") mdi-file-pdf-box
        | {{ $t('download_as_pdf') }}
      v-btn.round-lg.text-md.font-bold.text-none.pl-5.pr-4.py-3.mt-4(color="basic700" outlined depressed height="48" @click="downloadPng")
        v-icon.mb-1(left color="basic700") $yzi-download-01
        | {{ $t('download_as_png') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VueQrcode from '@chenfengyuan/vue-qrcode'

export default {
  components: { VueQrcode },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
  },
  data () {
    return {
      embedSelection: null,
      htmlContent: null,
      rules: {
        not_empty: [v => v.trim().length || 'This field is required'],
        not_empty_array: [v => !!(v && v.length) || 'This field is required']
      },
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    copyUrl() {
      this.showMessage(['success', this.$t('success_message.link_copied_to_clipboard')])
    },
    getQRLinkURL () {
      if (process.env.VUE_APP_ENV === 'prod') {
        return `https://review.yezza.co/review/${this.company.slug}`
      }
      return `https://review-test.yezza.co/review/${this.company.slug}`
    },
    downloadPng () {
      var canvas = document.getElementById("reviewLink")
      var dataURL = canvas.toDataURL("image/png")
      const linkSource = dataURL
      const downloadLink = document.createElement('a')
      document.body.appendChild(downloadLink)
      downloadLink.href = linkSource
      downloadLink.target = '_self'
      downloadLink.download = 'QrCode'
      downloadLink.click()
    },
    downloadPdf () {
      let qrUrl = encodeURI(`https://${process.env.VUE_APP_BASE_DOMAIN}/pdf-qr?link=${this.getQRLinkURL()}`)
      let downloadUrl = `https://pdf.yezza.io/?url=${qrUrl}&type=pdf&filename=qrcode.pdf&waitUntil=networkidle0&printBackground=true&width=305&height=305`
      window.open(downloadUrl)
    }
  },
}
</script>

<style scoped>

</style>